import styled from 'styled-components'

export const PressCentreContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: 2.4rem;
  padding-right: 2.4rem;
  justify-content: space-between;
  padding-top: 2.5rem;
  margin-bottom: 3.2rem;
  border-top: 1px solid ${props => props.theme.colors.black};

  @media screen and (min-width: ${props => props.theme.responsive.small}) {
    flex-direction: row;
    padding-left: 0;
    padding-right: 0;
    margin-bottom: 5.6rem;
  }

  .publishYear {
    flex: 1;
  }

  .pressAccordion {
    flex: 4;
  }
  .publishDate {
    color: ${props => props.theme.colors.brownGrey};
    font-size: 1.6rem;
  }

  .docLink {
    color: ${props => props.theme.colors.black};
    background-image: url(../document.svg);
    background-repeat: no-repeat;
    padding-left: 3rem;
    font-size: 1.4rem;
  }
`
